// extracted by mini-css-extract-plugin
export default {"input":"PincodeModal_input__n-l81"};